export class CModelItem {
  public security: any;
  public price: number;
  public quantity: number;
  public semdexPercentage: number;
  public modelPercentage: number;
  public portfolioValue: number;
  public sector: string;
  public geography: string;
  public assetClass: string;
  public isNew: boolean;
  public isDeleted: boolean;
  public lastPrice: number;

  /** @ngInject */

  constructor(private cModelLineItem?: any) {
    let that = this;
    if (typeof cModelLineItem != "undefined") {
      this.setViewItemData(cModelLineItem);
    }
  }

  // Set the data for the View's Item model:
  setViewItemData(itemDTO: any) {
    switch (itemDTO.assetClass) {
      case "Equity":
        this.security = {
          id: itemDTO.equityItem.id,
          name: itemDTO.equityItem.name,
        };

        break;
      case "Fixed Income":
        this.security = {
          id: itemDTO.fixedIncomeItem.id,
          name: itemDTO.fixedIncomeItem.name,
        };
        break;
      case "Commodities":
        this.security = {
          id: itemDTO.preciousMetalItem.id,
          name: itemDTO.preciousMetalItem.name,
        };
        break;
      case "Cash":
        this.security = {
          id: itemDTO.cashItem.id,
          name: itemDTO.cashItem.name,
        };
        break;
    }

    this.price = itemDTO.price;
    this.lastPrice = itemDTO.lastPrice;
    this.quantity = itemDTO.quantity;
    this.portfolioValue = this.price * this.quantity;
    this.semdexPercentage = itemDTO.marketCapitalPercentage;
    this.modelPercentage = itemDTO.modelPercentage;
    if (itemDTO.geography != null) {
      this.geography = itemDTO.geography.name;
    }
    if (itemDTO.sector != null) {
      this.sector = itemDTO.sector.name;
    }
    this.assetClass = itemDTO.assetClass;
    this.isNew = false;
    this.isDeleted = false;
  }

  // Set the data for the Server's ItemDTO:
  getCModelItemDTOData() {
    let that = this;
    let itemDTO = {
      equityItem: null,
      cashItem: null,
      fixedIncomeItem: null,
      preciousMetalItem: null,
      price: that.price,
      lastPrice: that.lastPrice,
      quantity: that.quantity,
      marketCapitalPercentage: that.semdexPercentage,
      modelPercentage: that.modelPercentage,
      assetClass: that.assetClass,
    };

    switch (that.assetClass) {
      case "Equity":
        itemDTO.equityItem = {
          id: that.security.id,
          name: that.security.name,
        };
        break;
      case "Fixed Income":
        itemDTO.fixedIncomeItem = {
          id: that.security.id,
          name: that.security.name,
        };
        break;
      case "Commodities":
        itemDTO.preciousMetalItem = {
          id: that.security.id,
          name: that.security.name,
        };
        break;
      case "Cash":
        itemDTO.cashItem = {
          id: that.security.id,
          name: that.security.name,
        };
        break;
    }

    return itemDTO;
  }
}



// WEBPACK FOOTER //
// ./src/app/cmodel/cmodelitem.ts